module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "closable": false,
      "footer-hide": "",
      "title": "投诉",
      "class-name": "customer-complaint",
      "width": 600,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.modalChange
    },
    model: {
      value: (_vm.modalFade),
      callback: function($$v) {
        _vm.modalFade = $$v
      },
      expression: "modalFade"
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "height": "40px",
      "src": require("../images/yzslogo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("投诉与意见")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Icon', {
    staticClass: "closeIcon",
    attrs: {
      "type": "android-close",
      "size": "22"
    },
    on: {
      "click": function($event) {
        _vm.modalFade = false
      }
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticStyle: {
      "border-bottom-left-radius": "6px"
    },
    attrs: {
      "src": require("../images/banner7.png"),
      "width": "164px",
      "height": "400px",
      "alt": ""
    }
  }), _vm._v(" "), _c('Form', {
    ref: "complaintForm",
    staticStyle: {
      "width": "400px",
      "margin-left": "10px"
    },
    attrs: {
      "label-width": 80,
      "model": _vm.complaintForm
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('h2', [_vm._v("我们将尽快处理您的投诉意见！")]), _c('div', [_vm._v("*为必填项")])]), _vm._v(" "), _c('div', {
    staticClass: "label required",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("\n                您的邮箱：\n                "), (_vm.errorMessage.emailError != '') ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("(" + _vm._s(_vm.errorMessage.emailError) + ")")]) : _vm._e()]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "customerMail"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "例：yazuishou@yazuishou.com"
    },
    on: {
      "on-blur": _vm.validateCustomerMail
    },
    model: {
      value: (_vm.complaintForm.customerMail),
      callback: function($$v) {
        _vm.$set(_vm.complaintForm, "customerMail", $$v)
      },
      expression: "complaintForm.customerMail"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#929292"
    }
  }, [_vm._v("(处理结果将发送至您邮件)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "label required"
  }, [_vm._v("\n                投诉内容：\n                "), (_vm.errorMessage.contentError != '') ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("(" + _vm._s(_vm.errorMessage.contentError) + ")")]) : _vm._e()]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "complainContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6,
      "maxlength": 500,
      "placeholder": "请简要描述您的问题（500字内）"
    },
    on: {
      "on-blur": _vm.validateComplainContent
    },
    model: {
      value: (_vm.complaintForm.complainContent),
      callback: function($$v) {
        _vm.$set(_vm.complaintForm, "complainContent", $$v)
      },
      expression: "complaintForm.complainContent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "label",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("图片上传：(最多4张)")]), _vm._v(" "), _c('div', {
    staticClass: "upload-wrapper"
  }, [_vm._l((_vm.uploadList), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-item"
    }, [_c('img', {
      attrs: {
        "src": image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sign",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-trash-outline",
        "size": "18"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), (_vm.uploadList.length != 4) ? _c('div', {
    staticClass: "upload-item upload-box"
  }, [_c('Upload', {
    staticClass: "upload-file",
    attrs: {
      "multiple": "",
      "show-upload-list": false,
      "before-upload": _vm.handleUpload,
      "action": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "overflow": "hidden"
    }
  }, [_c('Icon', {
    staticStyle: {
      "height": "50px",
      "width": "50px"
    },
    attrs: {
      "type": "ios-plus-empty",
      "size": "47"
    }
  })], 1)])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "24px",
      "line-height": "24px",
      "color": "#ed3f14"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.uploadError)
    }
  })]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "warning",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.valiSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('Modal', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "mask-closable": false,
      "width": "300"
    },
    on: {
      "on-visible-change": function($event) {
        return _vm.modalChange(false)
      }
    },
    model: {
      value: (_vm.successModal.fade),
      callback: function($$v) {
        _vm.$set(_vm.successModal, "fade", $$v)
      },
      expression: "successModal.fade"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark-circled",
      "size": "60",
      "color": "#19be6b"
    }
  })], 1), _vm._v(" "), _c('h1', [_vm._v("提交成功")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("我们已经收到并且十分重视您的建议")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("请耐心等待，1个工作日内会联系您")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.successModal.fade = false;
        _vm.modalChange(false)
      }
    }
  }, [_vm._v("关闭")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d4d090ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4d090ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/customer-complaint.vue
// module id = 1323
// module chunks = 61